import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEvaluation, deleteEvaluation } from './evaluation.reducer';

export const EvaluationDeleteDialog = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId: string; id: string }>) => {
  const { ecoleid, anneeScolaireId, id } = props.match.params;
  const dispatch = useAppDispatch();
  const classeIdFromQuery = new URLSearchParams(props.location.search || '').get('classeId');

  useEffect(() => {
    dispatch(getEvaluation(id));
  }, []);

  const evaluationEntity = useAppSelector(state => state.evaluation.entity);
  const updateSuccess = useAppSelector(state => state.evaluation.updateSuccess);

  const handleClose = () => {
    if (classeIdFromQuery) {
      props.history.push(`/calendar/${ecoleid}/${anneeScolaireId}/${classeIdFromQuery}/calendarEntry?tab=2`);
      return;
    }
    props.history.push(`/evaluation/${ecoleid}/${anneeScolaireId}`);
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    if (!evaluationEntity.ecoleId || !evaluationEntity.anneeScolaireId) return;
    dispatch(deleteEvaluation({ id, ecoleId: evaluationEntity.ecoleId, anneeScolaireId: evaluationEntity.anneeScolaireId }));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="evaluationDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="korischoolApp.evaluation.delete.question">
        <Translate contentKey="korischoolApp.evaluation.delete.question" interpolate={{ id: evaluationEntity.titre }}>
          Are you sure you want to delete this Evaluation?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-evaluation" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EvaluationDeleteDialog;
